// extracted by mini-css-extract-plugin
module.exports = {"root":"FooterSecurity_root__yiYps","title":"FooterSecurity_title__QIy10","image":"FooterSecurity_image__1UxDH","paragraph":"FooterSecurity_paragraph__sPtJ_"};